import { render, staticRenderFns } from "./five.vue?vue&type=template&id=92b882aa"
import script from "./five.vue?vue&type=script&lang=js"
export * from "./five.vue?vue&type=script&lang=js"
import style0 from "./five.vue?vue&type=style&index=0&id=92b882aa&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports